import React from "react";
import { useTranslation } from "react-i18next";

const EmployeeChangedLocation = ({ notification }) => {
  const { t } = useTranslation();

  return (
    <>
      <h4 className="notification-title">
        {t("notification_employee_changed_location_title")}
      </h4>
      <p className="notification-subtitle">
        {t("notification_employee_changed_location_subtitle")}
      </p>
      <p className="subtitle-description">
        {t("notification_employee_changed_location_description")}
      </p>
    </>
  );
};

export default EmployeeChangedLocation;
